import cx from 'classnames';
import PropTypes from 'prop-types';

const SpacingBody = ({ data }) => {
  const { spacing } = data;

  const classes = cx('br-divider', {
    [`my-${spacing}`]: spacing,
  });

  return (
    <span
      className={classes}
      style={{
        '--border-color': 'transparent',
      }}
    ></span>
  );
};

SpacingBody.propTypes = {
  data: PropTypes.shape({
    spacing: PropTypes.string,
  }),
  isEditMode: PropTypes.bool,
};

export default SpacingBody;
